import { Component } from '@angular/core';
import { customCard } from 'src/app/shared/model/customCard';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-calculator-list',
    templateUrl: './calculator-list.component.html',
    styleUrl: './calculator-list.component.scss',
    standalone: false
})
export class CalculatorListComponent {
  calculatorList: customCard[] = [
    {
      icon: 'pi pi-calculator',
      title: 'calculatorList.basic.title',
      text: 'calculatorList.basic.text',
      link: 'home/basic-calculator',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-briefcase',
      title: 'calculatorList.holiday.title',
      text: 'calculatorList.holiday.text',
      link: 'home/holiday-calculator',
    },
    {
      icon: 'pi pi-globe',
      title: 'calculatorList.plane.title',
      text: 'calculatorList.plane.text',
      link: 'home/plane-calculator',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-file-import',
      title: 'calculatorList.file.title',
      text: 'calculatorList.file.text',
      link: 'home/file-import-calculator',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-calendar-minus',
      title: 'calculatorList.event.title',
      text: 'calculatorList.event.text',
      link: 'home/event-calculator',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-cog',
      title: 'calculatorList.integration.title',
      text: 'calculatorList.integration.text',
      link: 'home/integration',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-list',
      title: 'calculatorList.orders.title',
      text: 'calculatorList.orders.text',
      link: 'home/orders',
      style: environment.production ? { display: 'none' } : {},
    },
    {
      icon: 'pi pi-comments',
      title: 'calculatorList.contact.title',
      text: 'calculatorList.contact.text',
      link: 'home/contact',
      style: environment.production ? { display: 'none' } : {},
    },
  ];
}
